import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';

var WarehouseRentPage = function (_super) {
  __extends(WarehouseRentPage, _super);

  function WarehouseRentPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.loadingStatus = false;
    _this.total = 0;
    _this.columns = [];
    _this.warehouseList = [];
    _this.wisCode = '';
    _this.selectedList = [];
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.warehouseRentDetailExportFiledEnum = [];
    return _this;
  }

  WarehouseRentPage.prototype.getInitSearchData = function () {
    this.wisCode = '';
    return {
      wis_code: undefined,
      warehouse_code_list: undefined,
      timeArr: this.$util.getDefaultTimeCondition(),
      page_index: 1,
      page_size: 10
    };
  };

  WarehouseRentPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = selectedRowKeys;
  };

  WarehouseRentPage.prototype.created = function () {
    this.columns = [{
      title: this.t('单号'),
      dataIndex: 'wis_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('仓库'),
      scopedSlots: {
        customRender: 'warehouse'
      }
    }, {
      title: this.t('发生时间'),
      dataIndex: 'is_date',
      filterEmpty: true
    }, {
      title: this.t('计费类型'),
      dataIndex: 'charge_type_text',
      filterEmpty: true
    }, {
      title: this.t('数量'),
      align: 'right',
      scopedSlots: {
        customRender: 'isdb_total_qty'
      },
      filterEmpty: true
    }, {
      scopedSlots: {
        customRender: 'isdb_volume',
        title: 'isdb_volume_title'
      },
      align: 'right',
      filterEmpty: true
    }, {
      title: this.t('结算总金额'),
      scopedSlots: {
        customRender: 'total_amount'
      },
      align: 'right',
      filterEmpty: true
    }, {
      title: this.t('币别'),
      dataIndex: 'customer_currency',
      filterEmpty: true
    }, {
      title: this.t('备注'),
      dataIndex: 'note',
      scopedSlots: {
        customRender: 'note'
      }
    }, {
      title: this.t('操作'),
      width: 100,
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.queryWarehouseRentList(this.searchData);
    this.queryWarehouseList();
  };

  WarehouseRentPage.prototype.queryWarehouseRentList = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _i, _a, key, data, _b, list, _c, total;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            postData = {};

            for (_i = 0, _a = Object.keys(param); _i < _a.length; _i++) {
              key = _a[_i];

              if (!param[key] && param[key] !== 0) {
                continue;
              }

              if (key === 'timeArr') {
                if (param[key].length) {
                  postData.date_from = this.$util.formatDateTime(param[key][0]);
                  postData.date_to = this.$util.formatDateTime(param[key][1]);
                } else {
                  postData.date_from = '';
                  postData.date_to = '';
                }

                continue;
              }

              postData[key] = param[key];
            }

            postData.wis_code = this.wisCode ? [this.wisCode] : undefined;
            this.lastParams = this.$util.deepCopy(postData);
            return [4, this.$api.finance.queryWarehouseRentList(postData)];

          case 1:
            data = _d.sent().data;
            _b = data.list, list = _b === void 0 ? [] : _b, _c = data.total, total = _c === void 0 ? 0 : _c;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  WarehouseRentPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList = [];
    this.queryWarehouseRentList(this.searchData);
  };

  WarehouseRentPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  WarehouseRentPage.prototype.exportWarehouseRentDetails = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.finance.exportWarehouseRentDetails(param)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  WarehouseRentPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, date_from, date_to, _b, code, data, message;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip))];
              }

              postData.wis_code = this.selectedList;
              _a = this.lastParams, date_from = _a.date_from, date_to = _a.date_to;
              postData.date_from = date_from;
              postData.date_to = date_to;
            }

            return [4, this.$api.finance.exportWarehouseRentList(postData)];

          case 1:
            _b = _c.sent(), code = _b.code, data = _b.data, message = _b.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  WarehouseRentPage.prototype.handleTimeArrChange = function (data) {
    if (!data.length) {
      this.searchData.timeArr = this.$util.getDefaultTimeCondition();
    }
  };

  WarehouseRentPage.prototype.handlExportDetails = function (isDownload, wisCodeList) {
    return __awaiter(this, void 0, Promise, function () {
      var wisCodeDetail, postData;

      var _this = this;

      return __generator(this, function (_a) {
        wisCodeDetail = wisCodeList.map(function (code) {
          var item = _this.$util.findItemByKeyValue(_this.dataList, code, 'wis_code');

          return {
            wis_code: item === null || item === void 0 ? void 0 : item.wis_code,
            charge_time: item === null || item === void 0 ? void 0 : item.is_date
          };
        });
        postData = {
          wis_code_detail: wisCodeDetail,
          export_field_list: [],
          is_download: isDownload
        };

        if (!postData.wis_code_detail.length) {
          return [2, this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip))];
        }

        this.exportWarehouseRentDetails(postData);
        return [2];
      });
    });
  };

  WarehouseRentPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryWarehouseRentList(this.searchData);
  };

  WarehouseRentPage.prototype.initPage = function () {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  };

  WarehouseRentPage.prototype.handleReset = function () {
    this.initPage();
    this.searchData = this.getInitSearchData();
    this.queryWarehouseRentList(this.searchData);
  };

  __decorate([enumData('Finance/WarehouseRentDetailExportFiledEnum')], WarehouseRentPage.prototype, "warehouseRentDetailExportFiledEnum", void 0);

  __decorate([userPrefPageSize('warehouseCostStatementList')], WarehouseRentPage.prototype, "getInitSearchData", null);

  __decorate([loading('loadingStatus')], WarehouseRentPage.prototype, "queryWarehouseRentList", null);

  WarehouseRentPage = __decorate([Component], WarehouseRentPage);
  return WarehouseRentPage;
}(Vue);

export default WarehouseRentPage;